"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brFormattedCurrencyToNumber = exports.brNumberToFormattedCurrency = exports.peFormattedCurrencyToNumber = exports.peNumberToFormattedCurrency = exports.clFormattedCurrencyToNumber = exports.clNumberToFormattedCurrency = void 0;
var helpers_1 = require("./helpers");
var toNumber = function (whole, decimal) {
    if (!decimal) {
        return Number(whole) || 0;
    }
    return Number("".concat(whole, ".").concat(decimal)) || 0;
};
var setPrecision = function (number, precision) {
    if (precision === void 0) { precision = 0; }
    var value = number;
    if (!precision || precision === 0) {
        value = Math.ceil(number);
    }
    else {
        value = parseFloat(value).toFixed(precision);
    }
    return value;
};
var clNumberToFormattedCurrency = function (number, precision) {
    var value = setPrecision(number, precision);
    var numberAsString = "".concat(value);
    var _a = numberAsString.split('.'), whole = _a[0], decimal = _a[1];
    return (0, helpers_1.addCharToStr)(whole, '.', 3, ',', decimal);
};
exports.clNumberToFormattedCurrency = clNumberToFormattedCurrency;
var clFormattedCurrencyToNumber = function (str) {
    if (!str) {
        return null;
    }
    var stringWithoutDots = str.replace(/\./g, '');
    var _a = stringWithoutDots.split(','), whole = _a[0], decimal = _a[1];
    return toNumber(whole, decimal);
};
exports.clFormattedCurrencyToNumber = clFormattedCurrencyToNumber;
var peNumberToFormattedCurrency = function (number) {
    var numberAsString = "".concat(number);
    var _a = numberAsString.split('.'), whole = _a[0], decimal = _a[1];
    return (0, helpers_1.addCharToStr)(whole, ',', 3, '.', decimal);
};
exports.peNumberToFormattedCurrency = peNumberToFormattedCurrency;
var peFormattedCurrencyToNumber = function (str) {
    if (!str) {
        return null;
    }
    var stringWithoutCommas = str.replace(/,/g, '');
    var _a = stringWithoutCommas.split('.'), whole = _a[0], decimal = _a[1];
    return toNumber(whole, decimal);
};
exports.peFormattedCurrencyToNumber = peFormattedCurrencyToNumber;
exports.brNumberToFormattedCurrency = exports.clNumberToFormattedCurrency;
exports.brFormattedCurrencyToNumber = exports.clFormattedCurrencyToNumber;
